import React from 'react';
import PropTypes from 'prop-types';
import IconExclamationTriangle from '@spothero/icons/exclamation-triangle';
import TextButton from '@spothero/ui/text-button';

const SpotListNoResults = ({isAirport, numFilters, onResetFiltersClick}) => {
    return (
        <div className="SpotListNoResults">
            <IconExclamationTriangle />
            <div className="SpotListNoResults-content">
                <p>No Spots Found</p>
                {isAirport ? (
                    <p>
                        We might not have any parking available for these dates,
                        or we could be fully sold out.
                    </p>
                ) : (
                    <>
                        {numFilters > 0 ? (
                            <>
                                <p>
                                    Try removing some of the filters you&apos;ve
                                    applied.
                                </p>
                                <TextButton onClick={onResetFiltersClick}>
                                    Reset filters
                                </TextButton>
                            </>
                        ) : (
                            <p>
                                Try changing your search location or reservation
                                times. We might not have parking in this area,
                                or we could be sold out.
                            </p>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

SpotListNoResults.propTypes = {
    isAirport: PropTypes.bool,
    numFilters: PropTypes.number,
    onResetFiltersClick: PropTypes.func,
};

export default SpotListNoResults;
